import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LabMDM } from "./models/lab";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { CarrierState } from "./models/carrierState";
import { QcType } from "./models/qcType";
import { BusinessArea } from "./models/businessArea";
import { Machine } from "./models/machine";
import { Printer } from "./models/printer";
import { SeqConfig } from "./models/seqConfig";
import { Chemical } from "./models/chemical";
import { MachineType } from "./models/machineType";
import { Product } from "./models/product";
import { ChemicalCategory } from "./models/chemicalCatagory-enum";
import { LibType } from "./models/libType";
import { EchoConfig } from "./models/echoConfig";
import { SalesItemTypeConfig } from "./models/salesitemtype-config";
import { tap, timeout } from 'rxjs/operators';
import { StandardPrimer } from './models/standardPrimer';
import { Template } from './models/template';
import { SenderDTO } from './models/sender-dto';
import { KitsDTO } from './models/kits-dto';
import { ResultConfigDTO } from '../mdm-result-engine-config/model/result-config-dto';
import { ExternalSenderLoginDTO } from "./models/externalSenderLogin";
import { Manufacturers } from "./models/manufacturers";
import { BBResponseContainer } from "../common-services/response-container";
import { Tags } from "./models/tags";
import { TagSystem } from './models/tag-system';
import { WorkFlow } from "./models/workflow";

//Service used for crud opertaions on the master data
@Injectable()
export class MasterDataService {

    readonly LABMDMSERVICE = 'admin/mdm/lab';
    readonly BAMDMSERVICE = 'admin/mdm/ba';
    readonly QCTYPEMDMSERVICE = 'admin/mdm/qctype';
    readonly MACHINEMDMSERVICE = 'admin/mdm/machine';
    readonly PRINTERMDMSERVICE = 'admin/mdm/printer';
    readonly PRINTERMDMSERVICENONMDM = 'mdm/printer';
    readonly CARRIERSTATEMDMSERVICE = 'admin/mdm/carrier/state'
    readonly GETCOUNTRIESURL = 'admin/mdm/country'
    readonly SEQCONFIGMDMSERVICE = 'admin/mdm/seqConfig';
    readonly CHEMICALMDMSERVICE = 'admin/mdm/chemical';
    readonly HELATHCHECK = 'health_check';
    readonly MACHINETYPEMDMSERVICE = 'admin/mdm/machinetype';
    readonly PRODUCTMDMSERVICE = 'admin/mdm/product';
    readonly PRODUCTMDMSERVICENONMDM = 'mdm/product';
    readonly PRODUCTMDMSERVICEBMS = 'admin/mdm/product/bmsProductName';
    readonly ACCESSLOG = 'admin/mdm/accesslog';
    readonly LIBTYPEMDMSERVICE = 'admin/mdm/libtype';
    readonly ECHOCONFIGURATION = 'admin/mdm/echoConfig';
    readonly SITCONFIGURATION = 'admin/mdm/salesItemType';
    readonly STANDARDPRIMER = 'admin/mdm/primer/standard';
    readonly TEMPLATEMDMSERVICE = 'admin/mdm/print/template';
    readonly TEMPLATEMDMSERVICENONMDM = 'mdm/print/template';
    readonly SENDERMDMSERVICE = 'admin/mdm/sender';
    readonly KITMDMSERVICE = 'admin/mdm/kits';
    readonly WORKFLOWMDMSERVICE ='admin/mdm/workflow';
    readonly WORKFLOWMDMSERVICENONMDM ='mdm/workflow';

    readonly PROBLEMCATEGORYMDMSERVICE = 'admin/mdm/problemcategory';
    readonly PROBLEMMDMSERVICE = 'admin/mdm/problem';
    readonly RESULTPROCESSMDMSERVICE = 'admin/mdm/result-process';
    readonly RESULTENGINECONFIGSERVICE = 'admin/mdm/resultConfig';
    readonly EXTERNALSENDERLOGINSERVICE = 'admin/mdm/eslogin';
    readonly MANUFACTURERSERVICE = 'admin/mdm/machine/manufacturer';
    readonly SNPPROFILEMDMSERVICE='admin/mdm/snpProfile';
    readonly SNPPROFILEMDM='admin/mdm';
    readonly ORDERSENDERMDMSERVICE = 'mdm/sender';
    readonly ORDERPRODUCTMDMSERVICE = 'mdm/product';
    readonly INBOUNDFILEDATAMDMSERVICE = 'admin/mdm/inboundFileProcessing';
    readonly LIBRARYCONFIGURATION= "admin/mdm/libtype"
    readonly WORKFILEMDMSERVICE = 'mdm/workfile';
    readonly GENERICMDMSERVICE = 'admin/mdm/generic';
    readonly GENERICMDMSERVICEWITHNONADMIN = 'mdm/generic';

    constructor(private http: HttpClient) {
    }

    //Gets a list of labs
    getLabs(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of labs based on selected lab
    getLabsBasedOnSelectedLabForAppliedGenomics(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE + "/filter";
        let requestParam = new HttpParams().set('labId', lab._id);

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }


    //getLabsWithOptionalHistory
    getLabsWithOptionalHistory(active: boolean, includeHistory: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString())
            .set('includeHistory', includeHistory.toString());

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new Lab
    addLab(lab: LabMDM) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, lab).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a lab
    updateLab(lab: LabMDM) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, lab).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of carrierStates
    getCarrierStates(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of active carrierStates by labid
    getCarrierStatesActive(labId:string, active:boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString())
        .set('labId', labId);

    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
    }


    //Creates a new carrierState
    addCarrierState(carrierState: CarrierState) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, carrierState).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a carrierState
    updateCarrierState(carrierState: CarrierState) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, carrierState).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of qctypes
    getQCTypes(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new qcType
    addQcType(qcType: QcType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, qcType).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a qcType
    updateQcType(qcType: QcType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, qcType).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of machines
    getMachines(lab: LabMDM): Observable<BBResponseContainer> {


        let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE + "/covid";
        let requestParam = new HttpParams().set('labId', lab._id);

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));

    }
    //Creates a new machine
    addMachine(machine: Machine) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, machine).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a machine
    updateMachine(machine: Machine) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, machine).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of printers
    getPrinters(labId: string, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        let requestParam = new HttpParams();
        if(labId) {
          requestParam = requestParam.append("labId", labId);
        }
        if(active) {
          requestParam = requestParam.append("active", active.toString());
        }
        const options = { params: requestParam }

        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Creates a new printer
    addPrinter(printer: Printer) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, printer).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a printer
    updatePrinter(printer: Printer) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, printer).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of businessArea
    getBusinessAreas(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Creates a new businessArea
    addBusinessArea(businessArea: BusinessArea) {
        let url: string = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, businessArea).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a businessArea
    updateBusinessArea(businessArea: BusinessArea) {
        let url: string = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, businessArea).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of sequencer Configurations
    getSeqConfigs(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new sequencer Configuration
    addSeqConfig(seqConfig: SeqConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, seqConfig).pipe(timeout(environment.defaultTimeout),tap(event => { console.log("success"); }, error => {
            console.log("error");
            error.url = url;
        }));
    }

    //Updates a sequencer Configuration
    updateSeqConfig(seqConfig: SeqConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, seqConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Gets a list of countries
    getCountries(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.GETCOUNTRIESURL;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of chemicals
    getChemicals(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.CHEMICALMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new chemical
    addChemical(chemical: Chemical) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CHEMICALMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, chemical).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a chemical
    updateChemical(chemical: Chemical) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CHEMICALMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, chemical).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Retrives all service health information
    getHealthStatus(): Observable<any> {
        let url: string = environment.BB_APIGATEWAY_SERVICE_URL + this.HELATHCHECK;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Gets a list of machinetypes
    getMachineTypes(active: boolean, lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE + "/covid";
        let requestParam = new HttpParams().set('active', active.toString()).set("labId", lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));

    }

    //Creates a new machineType
    addMachineType(machineType: MachineType) {
        console.log("adding machineType Object : "+machineType);
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, machineType).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a machineType
    updateMachineType(machineType: MachineType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, machineType).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of product
    getProducts(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of product by workflow
    getProductsByWorkflow(labId: string, workflow: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICENONMDM+"/midPlexProduct/"+labId+"/"+workflow;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { // This is intentional
        }, error => {
            error.url = url;
        }));
    }

    //Creates a new product
    addProduct(product: Product) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, product).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a product
    updateProduct(product: Product) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, product).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProductsByLab(labId: string, active: boolean){
        let url: string = environment.BB_MDMSERVICE_URL + this.ORDERPRODUCTMDMSERVICE + '/midPlexProduct/' + labId ;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //to get sales item type
    getSalesItemType(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //to get sales item type
    getSalesItemTypeFilteredByLab(labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION + '/labId/' + labId ;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //to get sales item type
    getBmsProductName(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICEBMS;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //to get access log
    getAccessLog(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.ACCESSLOG;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of buffer Chemicals
    getActiveBufferChemicals(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.CHEMICALMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString())
                                           .set('category', ChemicalCategory.BUFFER);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of libtype
    getLibTypes(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LIBTYPEMDMSERVICE;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new libtype
    addLibType(libtype: LibType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LIBTYPEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, libtype).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a libtype
    updateLibType(libtype: LibType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LIBTYPEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, libtype).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of echo configurations
     getEchoCofigs(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.ECHOCONFIGURATION;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new echo configuration
    addEchoConfig(echoConfig: EchoConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ECHOCONFIGURATION;
        return this.http.post<BBResponseContainer>(url, echoConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    addSITConfiguration(salesItemTypeConfig: SalesItemTypeConfig){
        let url: string = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION;
        return this.http.post<BBResponseContainer>(url, salesItemTypeConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a echo configuration
    updateEchoConfig(echoConfig: EchoConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ECHOCONFIGURATION;
        return this.http.put<BBResponseContainer>(url, echoConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    updateSITConfiguration(salesItemTypeConfig: SalesItemTypeConfig){
        let url: string = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION;
        return this.http.put<BBResponseContainer>(url, salesItemTypeConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

     restartJobSchedularService() {
         let url = environment.BB_ORDER_CREATION_SCHEDULER_URL + 'restart';
         return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
             error.url = url;
         }));
     }

    //TO trigger job on given product
    triggerJob(salesItemTypeConfig: SalesItemTypeConfig) {
        let url: string = environment.BB_ORDERRECEPTION_SERVICE_URL + 'order/createOrder';
        return this.http.post<BBResponseContainer>(url, salesItemTypeConfig).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    getStandardPrimer(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    updateStandardPrimer(standardPrimer: StandardPrimer): any {
        let url: string = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.put<BBResponseContainer>(url, standardPrimer).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
    addStandardPrimer(standardPrimer: StandardPrimer): any {
        let url: string = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.post<BBResponseContainer>(url, standardPrimer).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Insert a template
    addTemplate(template: Template) {
        let url: string = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, template).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

    //Update a template
    updateTemplate(template: Template) {
        let url: string = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, template).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get all the templates from DB
  getTemplates(id: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        const requestParam = new HttpParams().set('labId', id);
        const options = { params: requestParam };
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    //Get all the templates from DB
    getSenders(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get the Active Templates from Master DB For passed lab
    getActiveTemplatesForLab(lab: LabMDM, active: boolean,entity:string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICENONMDM;
        let requestParam = new HttpParams().set('labId', lab._id).
                                            set('active', active.toString()).
                                            set('entity', entity);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
      }

    addSender(sender: SenderDTO) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, sender).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

    updateSender(sender: SenderDTO) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, sender).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    getMapOfSenders(labId: string, active: boolean): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.ORDERSENDERMDMSERVICE + "/mapOfSenders";
        let requestParam = new HttpParams().set('labId', labId).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
      }

    addKit(kit: KitsDTO) :  Observable<BBResponseContainer>{
        let url: string = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, kit).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

    updateKit(kit: KitsDTO) : Observable<BBResponseContainer> {
        let url: string = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, kit).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get all the templates from DB
    getKits(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getMachineSubTypes(machineType: string, labId: string) {
        let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE + '/subTypes/' + machineType + '/' + labId + '/' + true ;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProblemCategory(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    getProblemCategoriesList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE + '/all';
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    getActiveProblemCategoriesList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE + '/'+lab._id+ '/' +true;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProblemList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMMDMSERVICE + '/all';
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getResultProcessList(lab: LabMDM): Observable<BBResponseContainer> {
      let url = environment.BB_MDMSERVICE_URL + this.RESULTPROCESSMDMSERVICE;
      let requestParam = new HttpParams().set('labId', lab._id);
      const options = url ? { params: requestParam } : {};
      return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
          error.url = url;
      }));
  }

  findLabById(selectedLabId: string): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE + "/" + selectedLabId;
    return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
        error.url = url;
    }));
  }

  getSenderSpecificKits(selectedLabId: string, active: boolean): Observable<BBResponseContainer> {
      let url = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE + '/listBasedOnPCRAndExtraction';
      let requestParam = new HttpParams().set('labId', selectedLabId).set('active', active.toString());
      const options = url ? { params: requestParam } : {};
      return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

  getResultConfigList(lab: LabMDM): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.RESULTENGINECONFIGSERVICE;
    let requestParam = new HttpParams().set('labId', lab._id);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
        error.url = url;
    }));
  }

  getResultForKitCyclerResultCombo(selectedLabId: string, kitCyclerResultCombo: string): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/resultConfigExistence';
    let requestParam = new HttpParams().set('labId', selectedLabId).set('kitNameCyclerResultName', kitCyclerResultCombo);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
        error.url = url;
    }));
  }

  addResultLogic(resultLogic: ResultConfigDTO): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.RESULTENGINECONFIGSERVICE;
    return this.http.post<BBResponseContainer>(url, resultLogic).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

  updateResultLogic(resultLogic: ResultConfigDTO): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.RESULTENGINECONFIGSERVICE;
    return this.http.put<BBResponseContainer>(url, resultLogic).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

  getNamesForMachinesWithTypes(type: string, lab: string, active: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE + '/names/' + lab + '/' + active + '/' + type;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

    getKitsFromMDM(labID: string, swabRestriction: string, extractorKits: string, pcrKits: string): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/kits/kitTypes' + '/' + labID + '/' + swabRestriction;
    let requestParam = new HttpParams().set('extractorKits', extractorKits).set('pcrKits', pcrKits);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

    //Get all the external sender logins configured for the lab
    getExternalSenderLogins(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    addExternalSenderLogin(externalSenderLogin: ExternalSenderLoginDTO): Observable<BBResponseContainer>{
        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        return this.http.post<BBResponseContainer>(url, externalSenderLogin).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

    updateExternalSenderLogin(externalSenderLogin: ExternalSenderLoginDTO): Observable<BBResponseContainer>{
        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        return this.http.put<BBResponseContainer>(url, externalSenderLogin).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        }));
    }

  getManufacturerList(labId:string): Observable<BBResponseContainer>{
    let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
    let requestParam = new HttpParams().set('labId', labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url,options).pipe(tap(event => { }, error => {
        error.url = url;
    }));
  }
  updateManufacturer(selectedMasterList: Manufacturers) {
    let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
   return this.http.put<BBResponseContainer>(url,selectedMasterList).pipe(tap(event => { }, error => {
        error.url = url;
    }));
  }
  saveManufacturer(selectedMasterList: Manufacturers) {
    let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
    return this.http.post<BBResponseContainer>(url,selectedMasterList).pipe(tap(event => { }, error => {
        error.url = url;
    }));
  }
   getActiveMachineTypes(active:boolean,labId:string){
    let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
    let requestParam = new HttpParams().set('active', active.toString()).set("labId",labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

  getPattersFromManufacturer(manufacturerName:string, labId: string){
    let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE + '/' + manufacturerName;
    let requestParam = new HttpParams().set("labId",labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

  getTags(lab: LabMDM): Observable<any> {

    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tags'
    let requestParam = new HttpParams().set("labId",lab._id);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
        error.url = url;
    }));
}

addTag(tag: Tags): Observable<any>{
    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tags';
    return this.http.post<BBResponseContainer>(url, tag).pipe(timeout(environment.defaultTimeout),tap( error => {
        error.url = url;
    }));
}

updateTag(tag: Tags): Observable<any>{
    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tags';
    return this.http.put<BBResponseContainer>(url, tag).pipe(timeout(environment.defaultTimeout),tap( error => {
        error.url = url;
    }));
}

updateTagPlateForRun(tag:Tags): Observable<any>{
    let url = environment.BB_NGS_RUN_PLANNING_URL + 'run/tag/update';
    return this.http.put<BBResponseContainer>(url, tag).pipe(timeout(environment.defaultTimeout),tap( error => {
        error.url = url;
    }));
}

saveTagPlates(tag: Tags): Observable<any> {
        if(tag.serviceIdentifier==="Artic_Midplex") {
            let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'covid19Batch/tag/update';
            return this.http.put<BBResponseContainer>(url, tag).pipe(timeout(environment.defaultTimeout),tap( error => {
                error.url = url;
            }));
        } else {
            let url = environment.BB_NGS_LIB_PREP_URL + 'libprep/tag/update';
            return this.http.put<BBResponseContainer>(url, tag).pipe(timeout(environment.defaultTimeout),tap( error => {
                error.url = url;
            }));
        }
    }
  getMapOfTagsFromMDM(selectedLabId: string, tagSystem: string): Observable<any> {
    let url = environment.BB_MDMSERVICE_URL + 'mdm/tags/' + selectedLabId + '/' + tagSystem;
    return this.http.get<BBResponseContainer>(url).pipe(tap(error => {
        error.url = url;
    }));
  }

  getMapOfTagsFromMDMForPlannedTagPlates(selectedLabId: string,tagSystemName: string,flag: boolean ): Observable<any> {
    let url = environment.BB_MDMSERVICE_URL + 'mdm/tags/' + selectedLabId + '/' +tagSystemName;
    let requestParam = new HttpParams().set('flag', flag.toString());
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));

  }

  getMapOfTags(selectedLabId: string, tagSystem: string): Observable<any> {
    const url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/tags/" + selectedLabId + '/' + tagSystem;
    return this.http.get<any>(url).pipe(timeout(environment.defaultTimeout));
  }

    //Gets a list of printers filtered by lab id and entity type
    getFilteredPrintersForLabAndEntity(active: boolean, labid:string,labelTemplate:string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICENONMDM +'/filter';
        let requestParam = new HttpParams().set('active', active.toString()).set('labId',labid).set('entityFilter',labelTemplate);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }

    getTagsystem(lab: LabMDM): Observable<any> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem'
        let requestParam = new HttpParams().set("labId",lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }

    getTagActiveSystem(lab: LabMDM, active: boolean): Observable<any> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem'
        let requestParam = new HttpParams().set("labId",lab._id).set("active", active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }
    getActiveSendersForLab(labId: string) : Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE +'/listOfSenders';
        let requestParam = new HttpParams().set('labId',labId)
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }

    addTagSystem(tagSystem: TagSystem): Observable<any>{
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem';
        return this.http.post<BBResponseContainer>(url, tagSystem).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }

    updateTagSystem(tagSystem: TagSystem): Observable<any>{
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem';
        return this.http.put<BBResponseContainer>(url, tagSystem).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }

    checkExistance(labId: string,tagSystemName:string) : Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem/exist';
        let requestParam = new HttpParams().set('labId',labId).set("tagSystemName",tagSystemName)
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }

     //Gets a list of workflows
     getWorkFlows(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.WORKFLOWMDMSERVICE;
        let requestParam = new HttpParams().set("labId",lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
   //Gets a list of active workflows
    getActiveWorkFlows(lab: LabMDM,active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.WORKFLOWMDMSERVICE+'/active';
        let requestParam = new HttpParams().set("labId",lab._id).set("active", active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of active workflows by Lab,workflowGroup and processScale
    getActiveWorkFlowsByLabWorkflowGroup(lab: LabMDM,workflowGroup: string, processScale: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.WORKFLOWMDMSERVICENONMDM+'/workflowList';
        let requestParam = new HttpParams().set("labId",lab._id).set("workflowGroup", workflowGroup).set("processScale", processScale);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { // This is intentional
        }, error => {
            error.url = url;
        }));
    }


    //Creates a new workflow
       addWorkFlow(workFlow: WorkFlow) {
        let url: string = environment.BB_MDMSERVICE_URL + this.WORKFLOWMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, workFlow).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

      //updates a workflow
    updateWorkFlow(workFlow: WorkFlow) {
        let url: string = environment.BB_MDMSERVICE_URL + this.WORKFLOWMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, workFlow).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    getSNPProfiles(lab: LabMDM): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + this.SNPPROFILEMDMSERVICE;
        let requestParam = new HttpParams().set("labId",lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }

    getActiveSNPProfiles(lab: LabMDM,active: boolean): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + this.SNPPROFILEMDMSERVICE+"/active";
        let requestParam = new HttpParams().set("labId",lab._id).set("active", active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }

    addSNPProfile(formData: FormData) :  Observable<BBResponseContainer>{
        let url: string = environment.BB_MDMSERVICE_URL + this.SNPPROFILEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout));
    }

    updateSNPProfile(formData: FormData) :  Observable<BBResponseContainer>{
        let url: string = environment.BB_MDMSERVICE_URL + this.SNPPROFILEMDM+"/snpProfileUpdate";
        return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout));
    }

    getSNPThresHoldValueFromMDM(productName: string,lab:string): Observable<any> {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE+"/snpProfile";
        let requestParam = new HttpParams().set("productName",productName).set("labId", lab);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }

    //Gets a list of flowcells
    getFlowCells(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/flowcell/list";
        const options = {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //Creates a new flowcell
    addFlowCell(flowCellJson: string, labId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/flowcell";
        return this.http.post<any>(url, flowCellJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //updates a flowcell
    updateFlowCell(flowCellJson: string, labId: string, entityId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/flowcell/"+entityId;
        return this.http.put<any>(url, flowCellJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }


    //Gets a list of flowcells
    getAnalysis(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/analysis/list";
        const options = {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }


    addAnalysis(flowCellJson: string, labId: string) {

        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/analysis";
        return this.http.post<any>(url, flowCellJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //updates  analysis
    updateAnalysis(flowCellJson: string, labId: string, entityId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/analysis/"+entityId;
        return this.http.put<any>(url, flowCellJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }


    validateAnalysis(labId:string,sequencer:string,productId:string,active:boolean,analysisName:string){
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/analysis/"+labId+"/"+sequencer+"/"+productId+"/"+active+"/"+analysisName;
        const options = {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

     //Gets a list of Process
     getProcessData(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/process/list";
        const options = {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    getActiveProcessData(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/process/list";
        let requestParam = new HttpParams().set('activeIndicator', true.toString());

        const options = url ? { params: requestParam } : {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

    //Creates a new Process
    addProcess(inputJson: string, labId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/process";
        return this.http.post<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //updates a Process
    updateProcess(inputJson: string, labId: string, entityId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/process/"+entityId;
        return this.http.put<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

    //Gets a list of Process Type
    getProcessTypeData(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/processtype/list";
        const options = {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

    //Gets a list of Process Type
    getActiveProcessType(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/processtype/list";
        let requestParam = new HttpParams().set('activeIndicator', true.toString());

        const options = url ? { params: requestParam } : {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //Creates a new Process Type
    addProcessType(inputJson: string, labId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/processtype";
        return this.http.post<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //updates a Process Type
    updateProcessType(inputJson: string, labId: string, entityId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/processtype/"+entityId;
        return this.http.put<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

    //Gets a list of Station
    getStationData(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/station/list";
        const options = {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //Creates a new Station
    addStation(inputJson: string, labId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/station";
        return this.http.post<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //updates a Station
    updateStation(inputJson: string, labId: string, entityId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/station/"+entityId;
        return this.http.put<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //Gets a list of InBoundFile
    getInboundFileData(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + this.INBOUNDFILEDATAMDMSERVICE;
        let requestParam = new HttpParams().set("labId",labId);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }
    //Gets active productIds from analysis collections
    getProductIdsFromMDM(labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/analysis/productId/" + labId;
        const options = {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout), tap(error => {
          error.url = url;
        }));
      }
    //Gets a list of FileCONFIGURATION
    getLibrarayConfigurationData(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "admin/mdm/generic/" + labId + "/libTypes/list";

        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }

    //Gets a list of Workfile
    getWorkfileData(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/workfile/list";
        const options = {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

    //Gets a list of active Workfile Definition name by process step
    getWorkfileActive(labId:string, stepDisplayName:string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.WORKFILEMDMSERVICE+"/getWorkfile";
        let request = {
            'stepDisplayName' :  stepDisplayName,
            'labId' : labId
          };

        //const options = url ? { params: requestParam } : {};
        return this.http.put<BBResponseContainer>(url, request).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //creates new workfile
    addWorkfileData(inputJson: string, labId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/workfile";
        return this.http.post<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

    //updates an existing workfile
    updateWorkfile(inputJson: string, labId: string, entityId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + "/admin/mdm/generic/"+labId+"/workfile/"+entityId;
        return this.http.put<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //Get map of flowcell with read mode capabilities
    getMapOfFlowcellWithCapabilities(labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/flowcell/getFlowCellCapabilities/" + labId;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getSequencerMachines(labName:string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/machinetype/sequencer";
        let requestParam = new HttpParams().set('labName', labName);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    getProblemsByProblemCategory(_id: string, queryObj: any) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERICMDMSERVICEWITHNONADMIN + "/" + _id + "/problem/query";
        return this.http.post<any>(url, queryObj).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    getStepCategoryList(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + this.GENERICMDMSERVICE + "/"+ labId+"/stepCategory/list";
        return this.http.get<any>(url).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //creates new step Category
    addStepCategoryData(inputJson: string, labId: string) {
        let url: string = environment.BB_MDMSERVICE_URL +this.GENERICMDMSERVICE + "/"+labId+"/stepCategory";
        return this.http.post<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    //updates an existing step Category
    updateStepCategory(inputJson: string, labId: string, entityId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERICMDMSERVICE  + "/"+labId+"/stepCategory/"+entityId;
        return this.http.put<any>(url, inputJson).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

    //Get active stepcategory
    getStepCategoryActiveList(labId: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + this.GENERICMDMSERVICE + "/"+labId+"/stepCategory/list";
        let requestParam = new HttpParams().set("activeIndicator", "true");
        const options = url ? { params: requestParam } : {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }

    getWorkFileConfigForProcessStep(labId: string, queryObj: any): Observable<any> {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERICMDMSERVICEWITHNONADMIN + "/" + labId + "/workfile/query";
        return this.http.post<any>(url, queryObj).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));
    }
    getMapCountOfActiveTagSystem(labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/tags/getMapCountOfActiveTagSystem/" + labId;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    saveTagsExcel(formDataSave: FormData,serviceIdentifier: string) {
        if (serviceIdentifier === "Artic_Midplex") {
            let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/tagSystem/upload";
            return this.http.post<any>(url, formDataSave).pipe(timeout(environment.defaultTimeout), tap(error => {
                error.url = url;
            }));
        }
        else {
            let url = environment.BB_NGS_LIB_PREP_URL + "/libprep/tagSystem/upload";
            return this.http.post<any>(url, formDataSave).pipe(timeout(environment.defaultTimeout), tap(error => {
                error.url = url;
            }));

        }
    }

    saveTagsExcelForRun(formDataSave: FormData){
        let url = environment.BB_NGS_RUN_PLANNING_URL + "run/tagSystem/upload";
        return this.http.post<any>(url, formDataSave).pipe(timeout(environment.defaultTimeout), tap(error => {
            error.url = url;
        }));
    }

    getLanesFromFlowCell(selectedLabId: string, flowcell: string) {
        let url = environment.BB_MDMSERVICE_URL + "mdm/flowcell/lane?cellName=" + flowcell + "&lab=" + selectedLabId;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

}
